import styled from "@emotion/styled";
import DatePicker from "@mui/lab/DatePicker";

// todo check again
export const StyledDatePicker = styled(DatePicker)`
  .MuiInputAdornment-root > button > svg {
    color: ${({ theme }) => theme.extend.palette.grey.light};
  }
`;
